module.exports = __webpack_public_path__ + "media/images/area-badges/material-science-361d91efccca25b5f7bb781e017c362f.svg";